module.exports = __webpack_public_path__ + "img/exclamation.d688b3c3.svg";